import React from 'react';
import { Helmet } from 'react-helmet-async';
import { MessageSquare, ShieldCheck } from 'lucide-react';

const RisOgRos = () => {
  return (
    <div className="min-h-screen bg-white">
      <Helmet>
        <title>Ris og ros & Patientsikkerhed | Hellerup Lægehus</title>
        <meta name="description" content="Giv os ris eller ros, så vi kan forbedre vores service og patientsikkerhed. Læs om vores kvalitetssikring og utilsigtede hændelser her." />
        <meta property="og:title" content="Ris og ros & Patientsikkerhed | Hellerup Lægehus" />
        <meta property="og:description" content="Giv os ris eller ros, så vi kan forbedre vores service og patientsikkerhed. Læs om vores kvalitetssikring og utilsigtede hændelser her." />
        <html lang="da-DK" />
      </Helmet>

      {/* Hero Section */}
      <section className="bg-slate-50 pt-20 pb-12 md:pt-24 md:pb-16">
        <div className="max-w-7xl mx-auto px-6">
          <h1 className="text-4xl md:text-5xl font-sans font-medium text-black mb-6 leading-tight tracking-tight">
            Ris og ros
          </h1>
          <p className="text-lg text-slate-600 max-w-3xl leading-relaxed">
            I Hellerup Lægehus vil vi gerne have dine tilbagemeldinger, hvis der er ting, vi kan gøre bedre. 
            Og selvfølgelig også hvis I har positive oplevelser.
          </p>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-16 md:py-24">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
            <div className="lg:col-span-2 space-y-12">
              <div className="space-y-8">
                <div>
                  <h2 className="text-2xl font-sans font-medium text-black mb-4 tracking-tight">
                    Hvordan giver jeg feedback?
                  </h2>
                  <p className="text-slate-700 leading-relaxed">
                    Tilbagemeldinger kan gives til os mundtligt eller skriftligt via E-konsultation. 
                    Det er også muligt at aflevere et brev i receptionen. Vi værdsætter enhver form for konstruktiv feedback, 
                    da det hjælper os med at udvikle klinikken.
                  </p>
                </div>

                <div>
                  <h2 className="text-2xl font-sans font-medium text-black mb-4 tracking-tight">
                    Utilsigtede hændelser og fejl
                  </h2>
                  <p className="text-slate-700 leading-relaxed">
                    Vi er underlagt indrapportering af utilsigtede hændelser samt medicinbivirkninger, som vil blive gennemgået internt i klinikken og eksternt. 
                    Vi ønsker at lære af vores fejl for at sikre den bedst mulige behandling for vores patienter.
                  </p>
                </div>

                <div className="bg-slate-50 p-8 border-l-4 border-[#4b717a]">
                  <h2 className="text-xl font-sans font-medium text-black mb-4 tracking-tight">
                    Kvalitetssikring og patientsikkerhed
                  </h2>
                  <p className="text-slate-700 leading-relaxed">
                    Vores arbejdsgange og instrukser bliver løbende opdateret. Vores kliniske instrumenter og apparatur tjekkes regelmæssigt. 
                    Der foretages faste kalibreringer og kontroller af vores udstyr. Vi vægter patientsikkerheden højt og følger alle lovmæssige krav. 
                    Således kan du være sikker på, at vi er en ansvarsbevidst og opdateret klinik.
                  </p>
                </div>
              </div>
            </div>

            {/* Sidebar/Info Box */}
            <div className="lg:col-span-1">
              <div className="bg-[#4b717a] text-white p-8 space-y-6">
                <div className="flex items-center gap-3 mb-2">
                  <ShieldCheck className="w-6 h-6 text-white/90" />
                  <h3 className="text-xl font-sans font-medium">Vores løfte</h3>
                </div>
                <p className="text-white/90 text-sm leading-relaxed">
                  Vi tager alle henvendelser seriøst og bruger dem aktivt i vores kvalitetsarbejde. 
                  Din sikkerhed og tryghed er vores højeste prioritet.
                </p>
                <div className="pt-4 border-t border-white/20">
                  <div className="flex items-center gap-2 text-white/80">
                    <MessageSquare className="w-4 h-4" />
                    <span className="text-xs font-medium uppercase tracking-wider">Kontakt os i dag</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default RisOgRos;
